<template>
    <div class="Field__Component">
        <div>
            <slot>{{ getExpoType(value) }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value'],
    methods: {
        getExpoType(type) {
            switch (type) {
                case 0:
                    return 'תרגול';
                case 1:
                    return 'וידאו';
                case 2:
                    return 'סימולציה';
                case 3:
                    return 'חוק';
                case 4:
                    return 'פסיקה';
                case 5:
                    return 'ספרים';
                case 6:
                    return 'דיוני';
                case 7:
                    return 'מהותי';
                case 8:
                    return 'דלתא';
                case 9:
                    return 'אינטרוולים';
                case 10:
                    return 'מיומנות';
                case 11:
                    return 'מקוצרת';
                case 12:
                    return 'ניסוח';
                case 13:
                    return 'מפגשים';

                default:
                    return 'תרגול';
            }
        }
    }
};
</script>

<style scoped></style>
